<template>
  <div class="home" id="home" name="home">
    <!-- 轮播图 -->
    <div class="block">
      <div>
        <el-row class="home-bg">
          <el-col :span="12">
            <div style="">
              <div style="font-size: 2rem;font-weight: bold;">
                图片搜索 图片分类 图片查重
              </div>
              <div style="font-size: 2rem;font-weight: bold;margin-top: 30px;">DetectTextInDesktop
              </div>
              <div style="margin-top: 15px;">
                一款可以根据文字进行图片搜索、图片分类、图片查重的软件：<br>
                ✓ 图片搜索：既可以在Windows目录中搜索图片中的文字，也可以在Word<br>
                &nbsp;&nbsp; 文档中搜索图片中的文字。效果如同对文本文档做文字搜索。<br>
                ✓ 图片分类：根据指定的多个分类关键字对图片自动分类。<br>
                ✓ 图片查重：根据指定位置的文字找出重复的图片。<br>
              </div>
              <div style="margin-top: 15px;">
                使用过程中如有疑问，欢迎咨询微信客服：zhsh10000com，或QQ客服：{{this.$store.getters.getQQService}}。
              </div>

<!--              <div style="margin-top: 10px;display: flex">
                <div style="text-align: center">
                  <el-image
                      style="width: 100px; height: 100px;"
                      :src="weixingUrl"
                      :preview-src-list="srcList">
                  </el-image>
                  <div>客服微信二维码</div>
                </div>
                <div style="margin-left: 30px;text-align: center">
                  <el-image
                      style="width: 100px; height: 100px;"
                      :src="qqUrl"
                      :preview-src-list="srcList">
                  </el-image>
                  <div>客服QQ二维码</div>
                </div>
              </div>-->

              <el-button @click="handleDownTest()" type="primary"
                         style="background-color: #0C75EA;color: #FFFFFF;margin-top: 10px;">免费下载
              </el-button>
              <div style="margin-top: 10px;">
                <img src="../assets/imgs/1.png"/>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 轮播图END -->

    <div class="main-box">
      <div class="main-box-label"
           style="text-align: center;margin-top: 10px;font-size: 1.75rem;;color: #141828;padding: 1.25rem 0">全部商品
      </div>
      <div class="main">
        <div class="list">
          <MyList :list="productList"></MyList>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {
  list
} from "@/api/productApi"
import {Download, getDownloadStream, getDownloadTest, getFileLibrary, saveDownLoadUser} from "@/api/download";
import {resolve} from "vue-carousel-3d";

export default {
  name:'Purchase',
  data() {
    return {
      productList: [], // 手机商品列表
      total: 0,
      maxPageNum: 0, // 最大分页数
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      fileName: '',
      downloadFile: '',
      weixingUrl: require('../assets/imgs/kefu/weixing.png'),
      qqUrl: require('../assets/imgs/kefu/qq.png'),
      srcList:[require('../assets/imgs/kefu/weixing.png'),require('../assets/imgs/kefu/qq.png')]
    };
  },
/*  deactivated() {
    this.$destroy()
  },*/
  created() {
    // 获取各类商品数据
    this.getPromo();
    getFileLibrary().then((res) => {
      this.fileName = res.data.fileName + "." + res.data.fileFormat;
      this.downloadFile = res.data;
    })
  },
  mounted() {
    // 监听页面滚动
    window.onscroll = this.pageScroll;
  },
  methods: {
    // 获取各类商品数据方法封装
    getPromo() {
      list(this.queryParams).then((res) => {
        this.total = res.total
        this.maxPageNum = Math.ceil(res.total / this.queryParams.pageSize)
        this.productList = this.productList.concat(res.rows)
      })
    },

    // 点击下载文件
    Download() {
      // 构建一个file对象
      let file = {}
      // 需要用到的内容
      file.fileName = this.downloadFile.fileName;
      file.path = this.downloadFile.path;
      file.fileSize = this.downloadFile.fileSize;
      /*      Download().then((res)=>{
              const blob = new Blob([res])
              console.log(this.fileName)
              saveAs(blob, decodeURIComponent(this.fileName))
            })*/

      // 这个file 可以是请求素材库获取的文件


      file.downloadingStop = false;
      file.downloadSpeed = "0 M/s";
      file.downloadPersentage = 0;
      file.blobList = [];
      file.chunkList = [];
      // 此处应是进度条  可以不用
      // downloadingFileList.value.push(file);

      this.downloadChunk(1, file);
    },

    //点击下载文件分片
    downloadChunk(index, file) {
      let chunkSize = 1024 * 1024 * 5;
      let chunkTotal = Math.ceil(file.fileSize / chunkSize);

      if (index <= chunkTotal) {

        let exit = file.chunkList.includes(index);

        if (!exit) {
          if (!file.downloadingStop) {
            let formData = new FormData();
            formData.append("fileName", file.fileName);  //文件的实际名字 这个可以传
            formData.append("md5", file.path); // 文件的存储路基
            formData.append("chunkSize", chunkSize);
            formData.append("index", index);
            formData.append("chunkTotal", chunkTotal);
            if (index * chunkSize >= file.size) {
              chunkSize = file.size - (index - 1) * chunkSize;
              formData.set("chunkSize", this.chunkSize);
            }
            const startTime = new Date().valueOf();

            getDownloadTest(formData).then((res) => {
              // console.log("============== 请求结果",res)
              file.chunkList.push(index);
              let endTime = new Date().valueOf();
              let timeDif = (endTime - startTime) / 1000;
              file.downloadSpeed = (5 / timeDif).toFixed(1) + " M/s";

              file.downloadPersentage = parseInt((index / chunkTotal) * 100);
              // var chunk = res.data.data.chunk
              // const blob = new Blob([res.data]);
              // 此处返回的就是文件的数据
              let blob = res;

              file.blobList.push(blob);

              //此处判断文件是否进行下载 合并
              if (index === chunkTotal) {
                const resBlob = new Blob(file.blobList, {
                  type: "application/octet-stream",
                });
                let url = window.URL.createObjectURL(resBlob); // 将获取的文件转化为blob格式
                let a = document.createElement("a"); // 此处向下是打开一个储存位置
                a.style.display = "none";
                a.href = url;
                // 下面两行是自己项目需要的处理，总之就是得到下载的文件名（加后缀）即可
                const fileName = file.fileName;
                a.setAttribute("download", fileName);
                document.body.appendChild(a);
                a.click(); //点击下载
                document.body.removeChild(a); // 下载完成移除元素
                window.URL.revokeObjectURL(url); // 释放掉blob对象
              }
              this.downloadChunk(index + 1, file);
            });
          }
        } else {
          file.downloadPersentage = parseInt((index / chunkTotal) * 100);
          this.downloadChunk(index + 1, file);
        }
      }
    },


    // 流式文件下载  --下载速度问题
    handleDown () {

      let param =  new FormData();
      param.set("path",this.downloadFile.path)
      getDownloadStream(param).then(response => {

        if (!response) {
          return
        }

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(new Blob([response]))
        link.target = '_blank'
        // 文件名称
        let filename = this.downloadFile.fileName
        link.download = decodeURI(filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },

    // 访问服务器直接下载 这样应该可以在浏览器中显示进度条
    handleDownTest(){
      let path = this.downloadFile.path;
      //判断用户是否登录
/*      if (this.$store.getters.getUser===''){
        //如果没有登录，跳转到主页并提示用户登录
        this.$router.push('/');
        alert("请先登录")
        return;
      }*/
      path =  path.replace("/data/jianquan/uploadPath","/profile")
      window.open(
          this.$targetUrl + path,
          '_self',
          'headers = {"Custom-Authorization",Bearer ' + this.$store.getters.token + '}',
      );
      // 在这里通知服务器用户x开始下载
      //请求时带上素材库id 用来查询用户下载的版本  --请求一下就行，不需要长期监控
      let param =  new FormData();
      param.set("libraryId",this.downloadFile.libraryId)
      saveDownLoadUser(param);
    },


    pageScroll() {
      // 获取滚动的距离
      let scrollTop = document.documentElement.scrollTop;
      // 获取滚动的高度（获取整个html的高度）
      let scrollHeight = document.documentElement.scrollHeight;
      // 获取屏幕(浏览器)高度
      let clienHeight = document.documentElement.clientHeight;
      // 滚动的距离 + 屏幕高度 - 内容高度 >= 0 表示滚动到底部了      (下拉加载判断条件)
      if (scrollTop + clienHeight - scrollHeight >= 0) {
        this.queryParams.pageNum++;
        if (this.queryParams.pageNum > this.maxPageNum) {
          return
        }
        //滚动至底部后请求数据
        this.getPromo();
      }
    }
  }
};
</script>
<style scoped>
@import "../assets/css/index.css";

/*.main-box-label {
  position: relative;
  text-align: center;
  font-size: 1.75rem;
  padding: 1.25rem 0;

  &::before {
    content: "";
    position: absolute;
    //background: url(../assets/imgs/shop-label.png);
    width: 45px;
    height: 20px;
    left: calc(100% - 48% - 142px);
    top: 1.9375rem;
  }

  &::after {
    content: "";
    position: absolute;
    //background: url(../assets/imgs/shop-label.png);
    width: 45px;
    height: 20px;
    right: calc(100% - 48% - 142px);
    top: 1.9375rem;
  }
}*/
</style>
